import Stack from '@mui/material/Stack';
import Icon from 'presentation/icons';
import React, {PropsWithChildren} from 'react';
import {HeaderSubTitle, HeaderTitle, StyledHeader} from './styles';
import {HeaderRootProps, HeaderSubtitleProps} from './types';

function HeaderRoot({
	children,
	title,
	onClickBackButton,
	onClickCloseButton,
	customPadding,
	customGap,
	showCloseButton = true,
	dataTagId,
}: PropsWithChildren<HeaderRootProps>) {
	return (
		<StyledHeader customPadding={customPadding} customGap={customGap}>
			<Stack direction="row" alignItems="center">
				<Icon
					data-tag-id={dataTagId}
					onClick={onClickBackButton}
					name="arrow-left-filled"
				/>
				<HeaderTitle variant="h6">{title}</HeaderTitle>
				{onClickCloseButton && showCloseButton ? (
					<Icon
						name="close-filled"
						onClick={onClickCloseButton}
						data-testid="header-root-close-button"
					/>
				) : null}
			</Stack>
			{children}
		</StyledHeader>
	);
}

function HeaderSubtitle({children}: HeaderSubtitleProps) {
	return <HeaderSubTitle variant="h6">{children}</HeaderSubTitle>;
}

export const PageHeader = {
	Root: HeaderRoot,
	Subtitle: HeaderSubtitle,
};
